import { render, staticRenderFns } from "./factura-new.vue?vue&type=template&id=51236f4e&scoped=true&"
import script from "./factura-new.vue?vue&type=script&lang=js&"
export * from "./factura-new.vue?vue&type=script&lang=js&"
import style0 from "./factura-new.vue?vue&type=style&index=0&id=51236f4e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51236f4e",
  null
  
)

export default component.exports